import {setUserConsent} from '../../../services/rest/userConsent';

/**
 * Save complete feedback data for switching back to classic
 * @param feedbackData - Object containing reason, details, and contactMe preference
 * @returns Promise<void>
 */
export const saveMailboxFeedback = async (feedbackData: {
    type: string;
    reason: string;
    free_text: string;
    consent: string;
}): Promise<void> => {
    setUserConsent(2, JSON.stringify(feedbackData));
};
